export enum RoutesEnum {
  page404 = '*',
  home = '/',
  prizes = '/prizes',
  termsConditions = '/terms-conditions',
  faq = '/faq',
  history = '/history',
  myPick = '/my-pick',
  play = '/play/:id',
  profile = '/profile',
  weeklyStats = '/weekly-stats/:id',
  leaderboard = '/leaderboard/:id',
  notValidRequest = '/not-valid-request',
  rules = '/rules',
  rulesContest = '/rules/:id',
  redirectCallback = '/redirect-callback',
}
